<template>
  <div>
    <K2Row class="mb-3 feedFilter">
      <K2Row class="filterItemContainer customScroll mb-3 mb-md-0">
        <K2Row align="center" class="me-2 filterItem">
          <span class="label-control me-2">{{ lang('School') }}</span>
          <el-select v-model="school" :placeholder="lang('Select') + lang('School')" size="small" disabled @change="label => handleSchoolChange(label)">
            <el-option v-for="item in schoolList" :key="item.CONSchool" :label="item.SCH_Name" :value="item.CONSchool"> </el-option>
          </el-select>
        </K2Row>
        <K2Row align="center" class="me-2 filterItem">
          <span class="label-control me-2">{{ lang('Level2') }}</span>
          <el-select v-model="level" :placeholder="lang('Select Level')" size="small" @change="label => handleLevelChange(label)">
            <el-option v-for="item in levelList" :key="item.PK_Course_ID" :label="item.CRS_Course_Name" :value="item.PK_Course_ID"> </el-option>
          </el-select>
        </K2Row>
        <K2Row align="center" class="me-2 filterItem">
          <span class="label-control me-2">{{ lang('Class') }}</span>
          <el-select v-model="selectedClass" :placeholder="lang('Select Class')" size="small" :disabled="!level" @change="label => handleClassChange(label)">
            <el-option v-for="item in classList" :key="item.PK_Class_ID" :label="item.CLS_ClassName + ' ' + item.CLS_Batch" :value="item.PK_Class_ID">
            </el-option>
          </el-select>
        </K2Row>
        <K2Row align="center" class="me-2 filterItem">
          <span class="label-control me-2">{{ lang('Student') }}</span>
          <el-select v-model="selectedStudent" clearable :placeholder="lang('Select Student')" size="small" :disabled="!selectedClass">
            <el-option v-for="item in studentList" :key="item.Student_ID" :label="item.Student_Name" :value="item.Student_ID"> </el-option>
          </el-select>
        </K2Row>
        <K2Row align="center" class="me-2 filterItem">
          <span class="label-control me-2">{{ lang('Teacher') }}</span>
          <el-select v-model="selectedTeacher" :placeholder="lang('Select Teacher')" size="small">
            <el-option v-for="item in teacherList" :key="item.CONid" :label="item.CONname" :value="item.CONid"> </el-option>
          </el-select>
        </K2Row>
      </K2Row>

      <K2Button :background="uiVariable.color.button2" size="small" @onclick="handleFilterList">
        {{ lang('Filter Post') }}
      </K2Button>
    </K2Row>
    <K2Row class="mb-3" align="center">
      <K2Row v-for="(filter, i) of filterList" :key="`filter-${i}`" align="center" class="tag px-2 py-1 rounded-pill me-2">
        <span>{{ filter.displayName }}</span>
        <K2Text
          bold="true"
          link="true"
          :color="uiVariable.color.purple"
          class="material-icons"
          :style="'font-size:' + uiVariable.fontSize.md"
          @onclick="$delete(filterList, i)"
          >close
        </K2Text>
      </K2Row>
      <K2Text bold="true" link="true" :color="uiVariable.color.error" v-if="filterList.length > 0" @onclick="handleRemoveFilter()">
        {{ lang('Clear All') }}
      </K2Text>
    </K2Row>
  </div>
</template>

<script>
import DataSource from '../../../../data/datasource'
import { lang } from '../../../../locale'
import moment from 'moment'
import $ from 'jquery'
import Vue from 'vue'
import assets from '../../../../assets/assets'
import K2Row from '../../../../uiComponents/k2Row/k2Row'
import Cookies from 'js-cookie'
import K2Text from '../../../../uiComponents/k2Text/k2Text'
import uiVariable from '../../../../config/uiVariable'
import K2Button from '../../../../uiComponents/k2Button/k2Button'

export default {
  name: 'feedFilter',
  components: { K2Button, K2Text, K2Row },
  props: ['passStaffID', 'isParent', 'getFilterPost', 'passStudent'],
  data() {
    return {
      assets: assets,
      uiVariable: uiVariable,
      school: null,
      currentSchool: null,
      schoolList: [],
      filterList: [],
      level: null,
      levelList: [],
      selectedClass: null,
      classList: [],
      selectedStudent: null,
      studentList: [],
      selectedTeacher: null,
      teacherList: [],
    }
  },
  created() {},
  async mounted() {
    this.currentSchool = Cookies.get('userSchoolNameSession')
    this.school = Cookies.get('userSchoolNameSession')
    this.init()
  },
  methods: {
    lang,
    async init() {
      await this.getSchool()
      await this.getLevel()
      await this.getClass()
      await this.getTeacherList()
      if (this.passStudent) {
        this.selectedStudent = this.passStudent
        this.selectedStudent.displayName = this.selectedStudent.Full_Name
        this.selectedStudent.type = 'student'
        this.filterList.push(this.selectedStudent)

        if (this.passStaffID) {
          this.teacherList.forEach(m => {
            if (this.passStaffID === m.CONid) {
              m.displayName = m.CONname
              m.type = 'teacher'
              this.filterList.push(m)
            }
          })
        }

        this.$emit('getFilterPost', this.filterList)
        this.clearFilter()
      } else if (this.passStaffID) {
        this.selectedTeacher = this.passStaffID
        this.handleFilterList()
      }
    },
    async getSchool() {
      const response = await DataSource.shared.getUserSch()
      if (response) {
        this.schoolList = response.Table
        // this.getCurrentSchool();
      }
    },
    async getLevel() {
      this.levelList = await DataSource.shared.getFeedFilterLevelList()
    },
    async getClass() {
      const response = await DataSource.shared.getFeedFilterClassList()
      if (this.level) {
        let arr = []
        response.forEach(d => {
          if (d.PK_Course_ID === this.level) {
            arr.push(d)
          }
        })
        this.classList = arr
      } else {
        this.classList = response
      }
    },
    async getStudentList() {
      this.$vs.loading()
      const response = await DataSource.shared.LoadAttendanceListWithMode(this.selectedClass, 'GroupClasName')
      if (response) {
        this.studentList = response.Table
      }
      this.$vs.loading.close()
    },
    async getTeacherList() {
      this.teacherList = await DataSource.shared.getFeedFilterTeacherList()
    },
    // getCurrentSchool() {
    //   if (this.schoolList) {
    //     this.schoolList.forEach(m => {
    //       if (Cookies.get('schoolSession') === m.CONSchool) {
    //         m.displayName = m.CONname
    //         this.school = m;
    //       }
    //     })
    //   }
    // },
    handleSchoolChange(val) {
      // this.schoolList.forEach(m => {
      //   if (val === m.CONSchool) {
      //     this.handleFilterChange(m.SCH_Name)
      //   }
      // })
    },
    async handleLevelChange(val) {
      if (val) {
        await this.getClass()
      }
    },
    async handleClassChange(val) {
      if (val) {
        await this.getStudentList()
      }
    },
    clearFilter() {
      this.selectedStudent = null
      this.selectedClass = null
      this.level = null
      this.selectedTeacher = null
      // this.school = null;
    },
    handleFilterList() {
      if (this.selectedTeacher) {
        this.teacherList.forEach(m => {
          if (this.selectedTeacher === m.CONid) {
            m.displayName = m.CONname
            m.type = 'teacher'
            this.filterList.push(m)
          }
        })
      }

      if (this.selectedStudent) {
        this.studentList.forEach(m => {
          if (this.selectedStudent === m.Student_ID) {
            m.displayName = m.Student_Name
            m.type = 'student'
            this.filterList.push(m)
          }
        })
      } else if (this.selectedClass) {
        this.classList.forEach(m => {
          if (this.selectedClass === m.PK_Class_ID) {
            m.displayName = m.CLS_ClassName + ' ' + m.CLS_Batch
            m.type = 'class'
            this.filterList.push(m)
          }
        })
      } else if (this.level) {
        this.levelList.forEach(m => {
          if (this.level === m.PK_Course_ID) {
            m.displayName = m.CRS_Course_Name
            m.type = 'level'
            this.filterList.push(m)
          }
        })
      }
      // else if (this.school) {
      //     this.schoolList.forEach(m => {
      //         if (this.school === m.CONSchool) {
      //             m.displayName = m.SCH_Name;
      //             m.type = "school";
      //             this.filterList.push(m);
      //         }
      //     });
      // }
      this.$emit('getFilterPost', this.filterList)
      this.clearFilter()
    },
    handleFilterChange(val) {
      this.filterList.push(val)
    },
    handleRemoveFilter() {
      this.filterList = []
      this.$emit('getFilterPost', this.filterList)
    },
  },
}
</script>
